import apiClient from '@u/apiClient'
import { toTranslatedNamePayload } from '@u/helpers/translatableNames'
import actionsChift from '@/store/modules/settings/corporation/company/actions.chift'
import actionsSquareup from '@/store/modules/settings/corporation/company/actions.squareup'
import actionsDigiteal from '@/store/modules/settings/corporation/company/actions.digiteal'
import actionsBcSolutions from '@/store/modules/settings/corporation/company/actions.bcsolutions'
import actionsChiftInvoicing from '@/store/modules/settings/corporation/company/actions.chift_invoicing'
import FetchCompanyListController from '@/wayfinder/actions/App/Http/Controllers/Company/FetchCompanyListController'
import GetCompanyByIdController from '@/wayfinder/actions/App/Http/Controllers/Company/GetCompanyByIdController'
import GetCompanyActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/Company/GetCompanyActivitiesByIdController'
import GetAccountingCodeListByCompanyController from '@/wayfinder/actions/App/Http/Controllers/AccountingCode/GetAccountingCodeListByCompanyController'
import CreateCompanyController from '@/wayfinder/actions/App/Http/Controllers/Company/CreateCompanyController'
import UpdateCompanyController from '@/wayfinder/actions/App/Http/Controllers/Company/UpdateCompanyController'
import DeleteCompanyController from '@/wayfinder/actions/App/Http/Controllers/Company/DeleteCompanyController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  ...actionsChift,
  ...actionsSquareup,
  ...actionsDigiteal,
  ...actionsBcSolutions,
  ...actionsChiftInvoicing,

  // region fetch
  async fetchCompanyIndex({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(FetchCompanyListController.get())
      .then(async (response) => {
        await commit('setCompanyList', response.data.companies)
        await commit('setMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchCompanyIndex', reason)
      })
  },
  async fetchCompanyByID({ commit }, id) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetCompanyByIdController.get({ company: id }))
      .then(async (response) => {
        commit('setCompany', response.data.company)
        commit('setMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchCompanyByID', reason)
      })
  },
  async fetchNewCompany({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetNewModelController.get({ query: { model: 'company' } }))
      .then(async (response) => {
        await commit('setCompany', response.data.company)
        await commit('setMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchNewCompany', reason)
      })
  },
  fetchCompanyActivitiesByCompanyID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetCompanyActivitiesByIdController.get({
            company: payload.company_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchAccountingCodeList: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetAccountingCodeListByCompanyController.get({
            company: payload.company_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  async storeNewCompany({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })

    let formData = new FormData()
    // console.log(payload.company)
    formData.append(
      'data',
      JSON.stringify(toTranslatedNamePayload(payload.company))
    )
    if (payload.company.new_logo_file) {
      formData.append('new_logo_file', payload.company.new_logo_file)
    }

    await apiClient
      .route(CreateCompanyController.post(), formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(async (response) => {
        if (response.status === 201) {
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('storeNewCompany', reason)
      })
  },
  // endregion

  // region update
  async updateCompany({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })

    let formData = new FormData()

    formData.append(
      'data',
      JSON.stringify(toTranslatedNamePayload(payload.company))
    )
    if (payload.company.new_logo_file) {
      formData.append('new_logo_file', payload.company.new_logo_file)
    }

    await apiClient
      .formRoute(
        UpdateCompanyController.put({ company: payload.id }),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      .then((response) => {
        if (response.status === 201) {
          processSuccessCallback(payload)
        }
      })
      .catch((reason) => {
        console.error('updateCompany', reason)
      })
  },
  // endregion

  // region delete
  async deleteCompanyById({ commit }, payload) {
    await apiClient
      .route(DeleteCompanyController.delete.delete({ company: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setCompanyList', response.data.companies)
          await commit('setMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deleteCompanyById', reason)
      })
  },
  // endregion

  // region undoDelete
  async undoDeleteCompanyById({ commit }, payload) {
    await apiClient
      .route(DeleteCompanyController.undo.get({ id: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setCompanyList', response.data.companies)
          await commit('setMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('undoDeleteCompanyById', reason)
      })
  }
  // endregion
}
